import React from 'react'
import { BasicPageContext } from '../../context'
import CentrePage from './'

const BasicCentrePage = props => (
  <BasicPageContext.Provider value>
    <CentrePage {...props} />
  </BasicPageContext.Provider>
)

export default BasicCentrePage
